import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-17" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-18" data-mp="avd0itzoq0d6">
          5 Bonus Esclusivi
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-19" data-mp="frtljfbl7ym1">
          Valore totale{' '}
          <span className="font-bold text-amber-700 line-through" data-id="element-20" data-mp="1whr791cga5n">€148</span> —
          Inclusi oggi <span className="font-bold text-brand" data-id="element-21" data-mp="5xbga5qivv04">GRATIS</span> nel
          prezzo
        </p>

        <ol className="mt-9 space-y-4" data-id="element-22" data-mp="3o3g1488g9hol">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-23" data-mp="3t1hm4ypfrr2p" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-24" data-mp="1r9l9tmvg2d6v">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-28 w-24 shrink-0 object-contain sm:h-32 sm:w-28" data-id="element-25" data-mp="3dg4xas0exui3" />
              <div data-id="element-26" data-mp="3n54y8gyh6zyx">
                <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-27" data-mp="3n4mwx5wyhvk5">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-[11px] font-bold" data-id="element-28" data-mp="2zg3vnacbqj1k">
                  <span className="text-amber-700 line-through" data-id="element-29" data-mp="2uh0uw23dmyze">
                    valore {bonus.was}
                  </span>{' '}
                  <span className="text-brand" data-id="element-30" data-mp="38htpemtohu2i">GRATIS</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}